import {
  UPDATE_SEND_INVITE_EMAIL,
  SEND_INVITE_LOADING,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_ERROR,
  SEND_INVITE_CLEAR_MESSAGE,
  SET_TIMEOUT_ID,
  SET_IS_EXPANDED,
} from './actionTypes';

const initialState = {
  isExpanded: true,
  email: '',
  disabled: true,
  messageType: '',
  message: '',
  timeoutId: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE_SEND_INVITE_EMAIL:
      return {
        ...state,
        email: action.payload.email,
        disabled: action.payload.disabled,
      };
    case SEND_INVITE_LOADING:
      return {
        ...state,
        disabled: true,
      };
    case SEND_INVITE_SUCCESS:
      return {
        ...state,
        messageType: 'success',
        message: `Email invitation was sent to ${state.email}`,
        email: '',
      };
    case SEND_INVITE_ERROR:
      return {
        ...state,
        disabled: false,
        messageType: 'error',
        message: action.payload.error,
      };
    case SEND_INVITE_CLEAR_MESSAGE:
      return {
        ...state,
        messageType: '',
        message: '',
      };
    case SET_TIMEOUT_ID: {
      return {
        ...state,
        timeoutId: action.payload.timeoutId,
      };
    }
    case SET_IS_EXPANDED:
      return {
        ...state,
        isExpanded: !state.isExpanded,
      };
    default:
      return state;
  }
};

const init = (initialState) => ({ ...initialState });

export { initialState, init };

export default reducer;
